import React, { useState } from "react";
import styles from "./trial-performance-section.module.scss";
import { ArrowIconComponent } from "./arrow-icon.component";
import { DetailModal } from "../detail-modal";

export const TrialPerformanceSection = ({ isDistributor = true }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);

  const metrics = [
    {
      label: "New Trials",
      value: "124",
      percentage: "62.0%",
      changePercent: "+12.1%",
    },
    {
      label: "Extended Trials",
      value: "24",
      percentage: "12.0%",
      changePercent: "+2.5%",
    },
    {
      label: "Converted",
      value: "52",
      percentage: "26.0%",
      changePercent: "-5.3%",
    },
    {
      label: "Expired Trials",
      value: "12",
      percentage: "12.0%",
      changePercent: "-1.3%",
    },
    {
      label: "Avg. Trial Length",
      value: "18.5",
      percentage: "",
      unit: "days",
      icon: isDistributor ? "doubleArrow" : undefined,
      changePercent: isDistributor ? undefined : "5.3%",
      showEquals: !isDistributor,
    },
  ];

  return (
    <section
      className={styles.trialPerformanceSection}
      aria-label="Trial Performance Metrics"
    >
      {metrics.map((metric, index) => {
        const valueLength = metric.value.toString().length;
        const valueClass = valueLength > 3 
          ? styles.trialPerformanceMetricValueMedium 
          : valueLength > 2 
          ? styles.trialPerformanceMetricValueSmall 
          : styles.trialPerformanceMetricValueLarge;

        return (
          <article 
            key={index} 
            className={styles.trialPerformanceMetricCard}
            onClick={() => {
              setSelectedMetric(metric);
              setShowModal(true);
            }}
            style={{ cursor: 'pointer' }}
          >
            <header className={styles.trialPerformanceMetricCardHeader}>
              <div className={styles.trialPerformanceMetricCardHeaderContent}>
                <h3 className={styles.trialPerformanceMetricLabel}>
                  {metric.label}
                </h3>

                {metric.changePercent && (
                  <div
                    className={styles.trialPerformanceChangeIndicator}
                    role="status"
                    aria-label={`Change: ${metric.changePercent}`}
                  >
                    {!metric.showEquals && (
                      <ArrowIconComponent isPositive={!metric.changePercent.startsWith('-')} />
                    )}
                    {metric.showEquals && (
                      <span className={styles.trialPerformanceEqualsSign}>=</span>
                    )}
                    <span
                      className={`${styles.trialPerformanceChangeText} ${
                        !metric.changePercent.startsWith('-')
                          ? styles.trialPerformanceChangeTextPositive
                          : styles.trialPerformanceChangeTextNegative
                      }`}
                    >
                      {metric.changePercent}
                    </span>
                  </div>
                )}

                {metric.icon === "doubleArrow" && !metric.changePercent && (
                  <div className={`${styles.trialPerformanceInlineFlex} ${styles.trialPerformanceItemsCenter} ${styles.trialPerformanceRelative} ${styles.trialPerformanceFlex0Auto}`}>
                    <ArrowIconComponent isPositive={true} isDouble={true} className="!relative !w-4 !h-4 !aspect-[1]" />
                  </div>
                )}
              </div>
            </header>

            <div className={styles.trialPerformanceMetricValueContainer}>
              <p className={`${styles.trialPerformanceMetricValue} ${valueClass}`} style={{ marginTop: 0, marginBottom: 0 }}>
                {metric.value}
              </p>

              <div className={styles.trialPerformanceMetricUnit}>
                <span className={styles.trialPerformanceMetricUnitText}>
                  {metric.unit || metric.percentage}
                </span>
              </div>
            </div>
          </article>
        );
      })}
      <DetailModal 
        show={showModal} 
        hideModal={() => setShowModal(false)}
        metric={selectedMetric}
      />
    </section>
  );
};